import * as types from "../actionTypes";

export const modalData = (data) => {
    return {
        type: types.PREMIUM_GUEST_MODAL_DATA,
        data
    };
};
export const closeModal = () => {
    return {
        type: types.PREMIUM_GUEST_CLOSE_MODAL
    };
};